import React from 'react';
import PropTypes from 'prop-types';
import { trans, withClientConfig } from '@spotahome/bff/client';
import JsonLdOrganization from '../microdata/components/JsonLdOrganization';

class SahContainer extends React.Component {
  static propTypes = {
    clientConfig: PropTypes.shape({
      googleMapsApiPlaceId: PropTypes.string.isRequired
    }).isRequired
  };

  render() {
    const description = trans('meta.description');
    const placeId = this.props.clientConfig.googleMapsApiPlaceId;

    return (
      <div>
        {this.props.children}
        <JsonLdOrganization description={description} />
      </div>
    );
  }
}

export default withClientConfig()(SahContainer);
